import { BOT_TYPES_LOADING, BOT_TYPES_SUCCESS, BOT_TYPES_FAILED
} from '../actions/chatbot.action';
import { botTypesInterface } from '../models/chatbotType.interface';

const initialState: botTypesInterface = {
    loading: true,
    error: false,
    message: "",
    bottype_data: [],
}

const botReducer = (state: botTypesInterface = initialState, action: any) : botTypesInterface => {
    switch (action.type) {
        case BOT_TYPES_LOADING:
            return {
                ...state,
                error: false,
                loading: true,
            }
        case BOT_TYPES_SUCCESS:
            return {
                ...state,
                loading: false,
                error: false,
                message: "",
                bottype_data: action.payload.respose.data,
            }
        case BOT_TYPES_FAILED: 
            return {
                ...state,
                loading: false,
                error: true,
                message: action.payload.error.message || ""
            }
        default:
            return state;
    }
}

export default botReducer;